import {EvChartView} from './evChartView';

export const EvChartPage = () => {
  return <EvChartView />;
};
